import { render, staticRenderFns } from "./First-Page.vue?vue&type=template&id=66e8ebf3&scoped=true"
import script from "./First-Page.vue?vue&type=script&lang=js"
export * from "./First-Page.vue?vue&type=script&lang=js"
import style0 from "./First-Page.vue?vue&type=style&index=0&id=66e8ebf3&prod&scoped=true&lang=scss"
import style1 from "./First-Page.vue?vue&type=style&index=1&id=66e8ebf3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66e8ebf3",
  null
  
)

export default component.exports